import { DATE_FORMAT_KEY } from 'src/stores/userInterfaceSettings/localStorageKeys';

export type DateFormatKey = 'd.m.yyyy' | 'dd.mm.yyyy' | 'dd/mm/yyyy' | 'long' | 'mm/dd/yyyy' | 'yyyy-mm-dd';

interface DateFormatOption {
	key: DateFormatKey;
	momentPattern: null | string;
	momentPatternWithShortYear: null | string;
	pickerToken: string;
}

const DEFAULT_DATE_FORMAT_OPTION: DateFormatOption = {
	key: 'dd.mm.yyyy',
	momentPattern: 'DD.MM.YYYY',
	momentPatternWithShortYear: 'DD.MM.YY',
	pickerToken: 'dd.mm.yy',
};

export const DEFAULT_DATE_FORMAT_KEY: DateFormatKey = DEFAULT_DATE_FORMAT_OPTION.key;

export const DATE_FORMAT_OPTIONS: ReadonlyArray<DateFormatOption> = [
	DEFAULT_DATE_FORMAT_OPTION,
	{ key: 'dd/mm/yyyy', momentPattern: 'DD/MM/YYYY', momentPatternWithShortYear: 'DD/MM/YY', pickerToken: 'dd/mm/yy' },
	{ key: 'mm/dd/yyyy', momentPattern: 'MM/DD/YYYY', momentPatternWithShortYear: 'MM/DD/YY', pickerToken: 'mm/dd/yy' },
	{
		key: 'yyyy-mm-dd',
		momentPattern: 'YYYY-MM-DD',
		momentPatternWithShortYear: 'YYYY-MM-DD',
		pickerToken: 'yy-mm-dd',
	},
	{ key: 'd.m.yyyy', momentPattern: 'D.M.YYYY', momentPatternWithShortYear: 'D.M.YY', pickerToken: 'd.m.yy' },
	{ key: 'long', momentPattern: null, momentPatternWithShortYear: null, pickerToken: 'dd.mm.yy' },
];

const DATE_FORMAT_OPTION_BY_KEY: ReadonlyMap<DateFormatKey, DateFormatOption> = new Map(
	DATE_FORMAT_OPTIONS.map((option) => [option.key, option])
);

function resolveOption(key: DateFormatKey): DateFormatOption {
	return DATE_FORMAT_OPTION_BY_KEY.get(key) ?? DEFAULT_DATE_FORMAT_OPTION;
}

function isDateFormatKey(value: null | string): value is DateFormatKey {
	return value !== null && DATE_FORMAT_OPTION_BY_KEY.has(value as DateFormatKey);
}

export function getDateFormatKey(): DateFormatKey {
	const stored = localStorage.getItem(DATE_FORMAT_KEY);
	return isDateFormatKey(stored) ? stored : DEFAULT_DATE_FORMAT_KEY;
}

export function momentDatePattern(key: DateFormatKey): null | string {
	return resolveOption(key).momentPattern;
}

export function momentDatePatternWithShortYear(key: DateFormatKey): null | string {
	return resolveOption(key).momentPatternWithShortYear;
}

export function pickerDateToken(key: DateFormatKey): string {
	return resolveOption(key).pickerToken;
}
